import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterMeasurementUnits'
})
export class FilterMeasurementUnitsPipe implements PipeTransform {

  /**
   * Devuelve 3 unidades: la unidad que está ligada al ingrediente, gramos y porción
   * @param array arreglo de unidades de medida
   * @param measureUnitId unidad de medida a filtrar (aparte de gramos)
   * @returns arreglo con únicamente la unidad de medida del ingrediente y gramos
   */
  transform(array: any[], measureUnitId: string): any[] {
    return array.filter(item => item.symbol_es === 'g' || item._id === 'porcion' || item._id === measureUnitId);
  }

}
